function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Generated queries to be used in our app.
 * These are the exact same as bootstrap's breakpoints
 *
 * 'min-widths' will always be the exact value of the breakpoint.
 *  This means that when specifing a min width, anything that is >= that width will be get the associated styles
 *  'max-widths' will always be the breakpoint - 0.02.
 *  This means that when specifing a max width, anything that is < the breakpoint width will be get the associated styles
 *
 * USAGE:
 * 'min-width' should be used to show a style AT OR OVER the specified breakpoint
 * 'max-width' should be used to show a style BELOW the specified breakpoint
 */
import { css } from './emotion';
export var mqSizes = {
  xl: 1200,
  lg: 992,
  md: 768,
  sm: 576,
  xs: 450
};
var mq = {};
export var query = {};
Object.keys(mqSizes).forEach(function (size) {
  query[size] = {
    min: "(min-width: ".concat(mqSizes[size], "px)"),
    max: "(max-width: ".concat(mqSizes[size] - 0.02, "px)") // This is to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths (bootstrap does the same)

  };
  mq[size] = {
    min: "@media ".concat(query[size].min),
    max: "@media ".concat(query[size].max)
  };
});
export var mobileOnly = _defineProperty({}, mq.md.min, {
  display: 'none'
});
export var mobileOnlyClass = css(mobileOnly);
export var desktopOnly = _defineProperty({}, mq.md.max, {
  display: 'none'
});
export var desktopOnlyClass = css(desktopOnly);
var xl = mq.xl,
    lg = mq.lg,
    md = mq.md,
    sm = mq.sm,
    xs = mq.xs;
export { xl, lg, md, sm, xs };
export default mq;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/styles/mediaQuery.js
// module id = 620
// module chunks = 0